import { Assets, Sprite } from "pixi.js"
import { containers, gameAssets } from "../gameUI"
import { scaleFactorScaleToFit } from "../utility"
import { clickToStopCommendation } from "../commendation"

export const setupDimmer = () => {
    if(!gameAssets.dimmer) gameAssets.dimmer = new Sprite(Assets.get('dimmer'))
        gameAssets.dimmer.anchor.set(0.5)
        gameAssets.dimmer.visible = false
        gameAssets.dimmer.alpha = 0
        gameAssets.dimmer.zIndex = 5001;
        containers.bgContainer.addChild(gameAssets.dimmer)
        gameAssets.dimmer.resize = (w, h) => {
            const expandFactor = 1
            gameAssets.dimmer.x = w * 0.5
            gameAssets.dimmer.y = h * 0.5
            gameAssets.dimmer.width = gameAssets.background.width * expandFactor
            gameAssets.dimmer.height = gameAssets.background.height 
    } 
}

export const setupSkipBtn = () => {
    if(!gameAssets.skipBtn) gameAssets.skipBtn = new Sprite(Assets.get('skip_btn_en'))
        gameAssets.skipBtn.anchor.set(0.5)
        gameAssets.skipBtn.visible = false
        gameAssets.skipBtn.position.set(260, -835)
        gameAssets.skipBtn.alpha = 0
        gameAssets.skipBtn.zIndex = 5005;
        gameAssets.dimmer.addChild(gameAssets.skipBtn)
}